import { render, staticRenderFns } from "./topic-reg-detail.vue?vue&type=template&id=4cf866b8&"
import script from "./topic-reg-detail.vue?vue&type=script&lang=js&"
export * from "./topic-reg-detail.vue?vue&type=script&lang=js&"
import style0 from "./topic-reg-detail.vue?vue&type=style&index=0&id=4cf866b8&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports